import { SagaIterator } from 'redux-saga';
import { call, delay } from 'redux-saga/effects';
import { fetch } from '../../Isomorphic/fetch';
import IBasicDriver from '../../NativeDevice/IBasicDriver';
import IConfig from '../../Display/IConfig';
import { getConfigurationBaseUrl } from '../Configuration/deviceConfigurationHelper';
import { NORMALLY } from '../../Intervals/constants';

const CHECK_SERVER_TIME_PERIOD = 10e3;
const MAX_TIMESTAMP_DIFF = 1000 * 3600 * 168; // 1 week
const TIME_PATH = '/time';

export function* checkServerTimeWhenRequested(
	getNativeDriver: () => IBasicDriver,
	defaultConfig: Pick<IConfig, 'configUrls'>,
	checkTimeBeforeConnection: boolean,
	getDeviceTimestamp: () => Promise<number>,
): SagaIterator {
	if (!checkTimeBeforeConnection) {
		return;
	}
	while (true) {
		const configBaseUrl: string = yield call(getConfigurationBaseUrl, getNativeDriver(), defaultConfig);
		const timeUri = `${configBaseUrl}${TIME_PATH}`;
		const response: Response = yield call(fetch, timeUri, undefined, NORMALLY);

		const headerTimestamp = response.headers.get('date');
		const { timestamp: serverTimestamp }: { timestamp: number } = headerTimestamp
			? { timestamp: new Date(headerTimestamp).getTime() }
			: yield call([response, response.json]);
		const deviceTimestamp: number = yield call(getDeviceTimestamp);

		if (Math.abs(deviceTimestamp - serverTimestamp) < MAX_TIMESTAMP_DIFF) {
			return;
		}
		yield delay(CHECK_SERVER_TIME_PERIOD);
	}
}
